import React, { type FC } from "react";

import { CustomTooltipLayout } from "../../../bottom_content/view/event-perspective/layout/CustomTooltipLayout";
import { Tooltip, type TooltipProps } from "../tooltip/Tooltip";

export interface ComponentTooltipProps extends Omit<TooltipProps, "title"> {
	componentName: string;
	componentType: string;
}

export const ComponentTooltip: FC<React.PropsWithChildren<ComponentTooltipProps>> = ({
	componentType,
	componentName,
	children,
	...rest
}) => (
	<Tooltip
		overlayStyle={{ minWidth: "180px" }}
		title={<ComponentTooltipBlock componentName={componentName} componentType={componentType} />}
		{...rest}
	>
		{children}
	</Tooltip>
);

export interface ComponentTooltipBlockProps {
	componentName: string;
	componentType: string;
}

export const ComponentTooltipBlock: FC<ComponentTooltipBlockProps> = ({ componentName, componentType }) => (
	<CustomTooltipLayout data-testid="component-tooltip-block">
		<Heading>Component</Heading>
		{componentName}
		<Heading>Type</Heading>
		{componentType}
	</CustomTooltipLayout>
);

const Heading: React.FC<React.PropsWithChildren> = (props) => (
	<div {...props} className="mt-2 mb-1.5 font-medium text-sm/4" />
);
